module.exports = __webpack_public_path__ + "static/media/RNSSanz-Normal.590f8162.ttf";